export const GET_TOKEN = 'GET_TOKEN';
export const GET_USER = 'GET_USER';

export const SET_PIPELINE = 'SET_PIPELINE'
export const SET_ALL_PIPELINES = 'SET_ALL_PIPELINES';

export const SET_COMPANY = 'SET_COMPANY'